import { useMutation } from "@tanstack/react-query";
import { useAxios } from "../../../api/axios";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const useLogout = async (
  onSuccess?: void | ((data: any) => void),
  onError?: void | ((error: any) => void)
) => {
  const { t } = useTranslation();
  const axios = useAxios();
  const navigate = useNavigate();
  const url = t("logout");
  return useMutation({
    mutationFn: async () => {
      const response = await axios.get(url);
      return response.data;
    },
    onSuccess: (data) => {
      if (onSuccess) {
        localStorage.removeItem("user-detail");
        localStorage.removeItem("salesforceAccessToken");
        localStorage.removeItem("showMap");
        localStorage.removeItem("layout");
        localStorage.removeItem("filter");
        localStorage.removeItem("map-persist");
        navigate("/");
        onSuccess(data);
      }
    },
    onError: (err) => {
      console.error("error", err);
      navigate("/");
      if (onError) {
        onError(err);
      }
    }
  });
};
